<template>
  <div>
    <vs-popup title="سند مرجع" :active.sync="showModal" fullscreen>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('Name') },
          { title: 'تعداد' },
          { title: 'ارزش کل' },
          { title: 'تخفیف' },
          { title: 'کمیسیون' },
          { title: $t('CreateOn') },
          { title: 'شناسه مرجع' }
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 40%">{{ row.productInfo.name }}</td>
          <td style="width: 5%">{{ row.productInfo.count }}</td>
          <td style="width: 10%">
            {{ Number(row.productInfo.productPrice).toLocaleString() }}
          </td>
          <td style="width: 10%">
            {{ row.productInfo.discountInfo.amount
            }}{{
              row.productInfo.discountInfo.discountType == 1 ? "درصد" : "ریال"
            }}
          </td>
          <td style="width: 10%">
            {{ row.amount }}{{ row.commissionType == 1 ? "درصد" : "ریال" }}
          </td>
          <td style="width: 15%; direction: ltr">
            {{ row.commissionQuery.createOn }}
          </td>
          <td style="width: 10%; direction: ltr">
            {{ row.commissionQuery.reasonId }}
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  props: {
    show: { default: false },
    partyid: "",
    showReferenceDocument: { default: false },
    reasonIdCurrent: ""
  },
  components: {
    "v-select": vSelect,
    DataGrid
  },
  data() {
    return {
      disabled: true,
      model: {},
      showError: true,
      modelName: "",
      gridDataSource: {}
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      createSalesPartnerPlan: "SalesPartnerPlan/createPlan"
    }),
    submitForm() {
      if (this.model.name != "") {
        this.createSalesPartnerPlan(this.model).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
            showConfirmButton: false,
            timer: 2000
          });

          this.$emit("finish");
          this.model.name = "";
        });
      } else {
        this.showError = false;
      }
    }
  },
  watch: {
    showReferenceDocument() {
      this.gridDataSource = {
        type: "app",
        service:
          "Credits/api/CommissionsQuery/items/reason/" + this.reasonIdCurrent
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    }
  }
};
</script>
